export default class GameMgr {

    static paths: string[] = ['unity-game'];

    static get checkGamePath(){
        const url = location.pathname;
        for(let i = 0; i < this.paths.length; i++){
            const path = this.paths[i];
            if (url && url.includes(path)){
                return true;
            }
        }
        return false;
    }
}